export * from './useDeleteCompanyTab';
export { default as useDeleteCompanyTab } from './useDeleteCompanyTab';
